import React from "react"
import { useSelector } from "react-redux"

import { MtProjectGroup } from "server/models"
import { StoreType } from "client/store"
import {
    Default,
    TableColumn,
} from "client/components"


const Columns = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
            formatter: (group: MtProjectGroup) => group.groupId,
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "150px",
            formatter: (group: MtProjectGroup) => (
                <>
                    {group.name}
                    {group.default && <Default marginLeft />}
                </>
            ),
        },
        {
            field: "description",
            header: lang.description,
            cellMinWidth: "200px",
            cellMaxWidth: "300px",
        },
        {
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        },
    ]

    return columns
}
export default Columns
